import type { RouteRecordRaw } from 'vue-router'
import { ROLE_GROUPS } from '../../constants/roleGroups'

const adminRoleMeta = { requiresAuth: true, requireRoles: ROLE_GROUPS.ADMIN_PANEL }

export const adminBoraLearnSettingsRoutes: RouteRecordRaw[] = [
  {
    path: 'boralearn/settings/levels',
    name: 'admin.boralearn.settings.levels',
    component: () => import('../../views/admin/boralearn/settings/LevelsSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Levels' },
  },
  {
    path: 'boralearn/settings/classes',
    name: 'admin.boralearn.settings.classes',
    component: () => import('../../views/admin/boralearn/settings/ClassesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Classes' },
  },
  {
    path: 'boralearn/settings/subjects',
    name: 'admin.boralearn.settings.subjects',
    component: () => import('../../views/admin/boralearn/settings/SubjectsSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Subjects' },
  },
  {
    path: 'boralearn/settings/topics',
    name: 'admin.boralearn.settings.topics',
    component: () => import('../../views/admin/boralearn/settings/TopicsSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Topics' },
  },
  {
    path: 'boralearn/settings/question-types',
    name: 'admin.boralearn.settings.question-types',
    component: () => import('../../views/admin/boralearn/settings/QuestionTypesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Question Types' },
  },
  {
    path: 'boralearn/settings/difficulty-levels',
    name: 'admin.boralearn.settings.difficulty-levels',
    component: () => import('../../views/admin/boralearn/settings/DifficultyLevelsSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Difficulty Levels' },
  },
  {
    path: 'boralearn/settings/practice-modes',
    name: 'admin.boralearn.settings.practice-modes',
    component: () => import('../../views/admin/boralearn/settings/PracticeModesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Practice Modes' },
  },
  {
    path: 'boralearn/settings/lesson-types',
    name: 'admin.boralearn.settings.lesson-types',
    component: () => import('../../views/admin/boralearn/settings/LessonTypesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Lesson Types' },
  },
  {
    path: 'boralearn/settings/content-formats',
    name: 'admin.boralearn.settings.content-formats',
    component: () => import('../../views/admin/boralearn/settings/ContentFormatsSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Content Formats' },
  },
  {
    path: 'boralearn/settings/lesson-statuses',
    name: 'admin.boralearn.settings.lesson-statuses',
    component: () => import('../../views/admin/boralearn/settings/LessonStatusesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Lesson Statuses' },
  },
  {
    path: 'boralearn/settings/visibility-types',
    name: 'admin.boralearn.settings.visibility-types',
    component: () => import('../../views/admin/boralearn/settings/VisibilityTypesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Visibility Types' },
  },
  {
    path: 'boralearn/settings/review-statuses',
    name: 'admin.boralearn.settings.review-statuses',
    component: () => import('../../views/admin/boralearn/settings/ReviewStatusesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Review Statuses' },
  },
  {
    path: 'boralearn/settings/question-owner-types',
    name: 'admin.boralearn.settings.question-owner-types',
    component: () => import('../../views/admin/boralearn/settings/QuestionOwnerTypesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Question Owner Types' },
  },
  {
    path: 'boralearn/settings/question-source-types',
    name: 'admin.boralearn.settings.question-source-types',
    component: () => import('../../views/admin/boralearn/settings/QuestionSourceTypesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Question Source Types' },
  },
  {
    path: 'boralearn/settings/assessment-types',
    name: 'admin.boralearn.settings.assessment-types',
    component: () => import('../../views/admin/boralearn/settings/AssessmentTypesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Assessment Types' },
  },
  {
    path: 'boralearn/settings/academic-periods',
    name: 'admin.boralearn.settings.academic-periods',
    component: () => import('../../views/admin/boralearn/settings/AcademicPeriodsSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'Academic Periods' },
  },
  {
    path: 'boralearn/settings/school-admin-titles',
    name: 'admin.boralearn.settings.school-admin-titles',
    component: () => import('../../views/admin/boralearn/settings/SchoolAdminTitlesSettingsView.vue'),
    meta: { ...adminRoleMeta, title: 'School Admin Titles' },
  },
  {
    path: 'boralearn/branding',
    name: 'admin.boralearn.branding',
    component: () => import('../../views/admin/settings/BrandingSettingsView.vue'),
    meta: { requiresAuth: true, requireRoles: ROLE_GROUPS.ADMINS, title: 'Branding & Social Links' },
  },
]
